import { useState } from "react";
import LayoutActividad from "../../../components/LayoutActividad";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { modulo12 } from "../../../routes/Module12";
import Sidebar from "../Sidebar";
import { faSignLanguage } from "@fortawesome/free-solid-svg-icons";
import Fondo from "../../../images/modulo12/fondoperiodico.png";
import Imagen4 from "../../../images/modulo12/entrevista.png";
import Imagen5 from "../../../images/modulo12/escuelacerrada.png";
import Imagen6 from "../../../images/modulo12/seguridad.png";
import InputRadioButton from "../../../components/InputRadioButton";
import GuiaDocente from "../../../components/GuiaDocente";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo12/Unidad2Actividad7.mp3";

const Actividad9 = () => {
  const [answers, setAnswers] = useState({
    ans1: { value: "", valid: "", correctValue: "respetar" },
    ans2: { value: "", valid: "", correctValue: "conversación" },
    ans3: { value: "", valid: "", correctValue: "acuerdo" },
    ans4: { value: "", valid: "", correctValue: "derechos" },
  });
  const infoUnidad = modulo12.content[1];
  const infoAct = modulo12.content[1].activities[9];
  const crumbs = [
    {
      title: modulo12.title,
      url: "/" + modulo12.url,
    },
    {
      title:
        modulo12.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titlePrev: `${modulo12.content[1].name}: ${modulo12.content[1].activities[8].name}`,
    linkPrev: `${modulo12.url}/${modulo12.content[1].path}/${modulo12.content[1].activities[8].path}`,
    titleNext: `${modulo12.content[1].name}: ${modulo12.content[1].activities[10].name}`,
    linkNext: `${modulo12.url}/${modulo12.content[1].path}/${modulo12.content[1].activities[10].path}`,
  };
  const metadata = {
    color: modulo12.color,
    title: `${modulo12.title} - ${infoAct.name}`,
    name: modulo12.title,
  };
  const handleAnswer = (label, value) => {
    setAnswers({
      ...answers,
      [label]: { ...answers[label], value },
    });
  };

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo12.color} hat-text`}>
          <FontAwesomeIcon icon={faSignLanguage} /> Hacemos
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
          <AudioPlayer track={Audio} />

      <ul className="">
        <li>Lee los siguientes titulares.</li>
        <li>
          Piensa: ¿crees que se trata de casos de discriminación? Marca SÍ o NO
          para cada caso.
        </li>
      </ul>

      <div className="row g-4 mt-3">
        <div className="col-md-4">
          <div>Titular 1</div>
          <div
            className="p-4"
            style={{
              backgroundImage: `url(${Fondo})`,
              backgroundRepeat: "no-repeat",
              backgroundSize: "100% 100%",
            }}
          >
            <h5 className="">
              Profesora universitaria impide ingreso a estudiante que no tenía
              plata para comprar libros del curso
            </h5>
          </div>
          <img src={Imagen4} className="img-fluid" alt="Peruanos" />
          <div className="mt-3">
            <InputRadioButton
              ans={answers.ans1}
              label="ans1"
              value="option1"
              text="Sí"
              handleAnswer={handleAnswer}
            />
            <InputRadioButton
              ans={answers.ans1}
              label="ans1"
              value="option2"
              text="No"
              handleAnswer={handleAnswer}
            />
          </div>
        </div>
        <div className="col-md-4">
          <div>Titular 2</div>
          <div
            className="p-4"
            style={{
              backgroundImage: `url(${Fondo})`,
              backgroundRepeat: "no-repeat",
              backgroundSize: "100% 100%",
            }}
          >
            <h5>
              Alumna no puede asistir al colegio por no pagar la cuota de APAFA
            </h5>
          </div>
          <img src={Imagen5} className="img-fluid" alt="Peruanos" />
          <div className="mt-3">
            <InputRadioButton
              ans={answers.ans2}
              label="ans2"
              value="option1"
              text="Sí"
              handleAnswer={handleAnswer}
            />
            <InputRadioButton
              ans={answers.ans2}
              label="ans2"
              value="option2"
              text="No"
              handleAnswer={handleAnswer}
            />
          </div>
        </div>
        <div className="col-md-4">
          <div>Titular 3</div>
          <div
            className="p-4"
            style={{
              backgroundImage: `url(${Fondo})`,
              backgroundRepeat: "no-repeat",
              backgroundSize: "100% 100%",
            }}
          >
            <h5>Chofer de combi no pudo entrar a tienda exclusiva</h5>
            <p className="mb-0">Le dijeron que “estaba llena”</p>
          </div>
          <img src={Imagen6} className="img-fluid" alt="Peruanos" />
          <div className="mt-3">
            <InputRadioButton
              ans={answers.ans3}
              label="ans3"
              value="option1"
              text="Sí"
              handleAnswer={handleAnswer}
            />
            <InputRadioButton
              ans={answers.ans3}
              label="ans3"
              value="option2"
              text="No"
              handleAnswer={handleAnswer}
            />
          </div>
        </div>
        <div className="col-lg-10 col-12">
          <ul className="mt-4">
            <li>
              Ahora escoge uno de los titulares donde hayas marcado SÍ y
              explícale a tu compañero, compañera o familiar por qué crees que
              es discriminación.{" "}
            </li>
          </ul>
        </div>
      </div>

      <GuiaDocente>
        <ul>
          <li>
            Mencione a niños y niñas que el objetivo de las actividades es que
            identifiquen casos de discriminación a partir del diálogo con sus
            compañeros. Asimismo, se busca que los niños y niñas se den cuenta
            de que se pueden tomar acciones concretas ante casos de
            discriminación.
          </li>

          <li>
            Lean la primera indicación: Lee los siguientes titulares. Pida a
            algunos niños o niñas que lean en voz alta los tres titulares que se
            presentan.
          </li>

          <li>
            Ahora lea la segunda indicación: Piensa: ¿crees que se trata de
            casos de discriminación? Marca SÍ o NO para cada caso. Déles un
            tiempo para que marquen, en los casilleros
            respectivos, si se trata o no de casos de discriminación. Ahora
            pídales que trabajen en parejas o con un familiar y lea la última indicación: Ahora
            escoge uno de los titulares donde hayas marcado SÍ y explícale a tu
            compañero o compañera por qué crees que es discriminación. Resalte
            que deben explicar las razones que los llevaron a marcar sí en el
            caso elegido. Es importante que recuerde que las
            opiniones pierden validez si no están bien fundamentadas. Finalmente
            recoja algunas opiniones sobre cada titular. Por
            ejemplo:
            <ul>
              <li>
                <i>
                  “¿El primer titular nos muestra un caso de discriminación? Sí.
                  Tal como nos explicó una compañera, en este caso, al alumno lo
                  están dejando sin clases por no tener recursos económicos
                  suficientes”.
                </i>
              </li>
            </ul>
          </li>

          <li>
            Continúe con el resto de titulares. Tenga en cuenta que los tres
            titulares muestran casos de discriminación. Cierre la actividad
            recordando que existen distintos tipos de discriminación (por lugar
            de origen, por carencia de recursos económicos, etc.).
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad9;
